//
// client-mgmt-nav.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    angular.module('curalate').directive('clientMgmtNav', () => ({
        restrict: 'E',
        templateUrl: '/app/components/client-mgmt/nav/client-mgmt-nav.html',
    }));
}))();
